// core
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RaptorManagerService {
  formData!: any;
  form!: any;
  step$: Observable<any>;
  private stepSubject: Subject<any>;


  constructor() {
    this.stepSubject = new Subject<any>();
    this.step$ = this.stepSubject.asObservable();
  }

  setStep(data: any): void {
    this.formData = data.formData;
    this.form = data.form;

    this.stepSubject.next(data);
  }

  // Raptor formData object
  getStepFormData(): any {
    return this.formData;
  }

  // Raptor form object
  getStepForm(): any {
    return this.form;
  }
}
